import { adapterFileFromApi } from "../adapters/files-adapter";
import { obtenerArchivosPorTags } from "../services/services";

const useGetFiles = () => {
    const getFiles = async (request) => {
        let arrayOfFiles = [];

        const files = await obtenerArchivosPorTags(request);

        //Adapto los archivos devueltos por la API, a un formato mas facil de manejar
        files.forEach((file) => {
            const adaptedFile = adapterFileFromApi(file);

            arrayOfFiles = [...arrayOfFiles, adaptedFile];
        });

        return arrayOfFiles;
    };

    return getFiles;
};
export default useGetFiles;
